const TYPE_CODES = {
  OTHER: [
    2,
    413,
    490,
    19,
    20,
    22,
    828,
    827,
    81,
    433,
    791,
    251,
    449,
    45,
    49,
    500,
    59,
    63,
    686,
    687,
    416,
    357,
    831,
    415,
    475,
    10,
    86,
    87,
    489,
    829,
    493,
    369,
    15,
    418,
    97,
    122,
    94,
    483,
    129,
    130,
    847,
    848,
  ],
  PDF: [
    26,
    468,
    8,
    11,
    550,
    17,
    350,
    494,
    834,
    56,
    745,
    438,
    836,
    423,
    392,
    521,
    381,
    363,
    125,
    126,
  ],
};

export default TYPE_CODES;
